import React, { useEffect, useState } from 'react'
import FeatherIcon from 'feather-icons-react';
import { Container } from 'react-bootstrap';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Step1 from './Includes/Step1';
import Step2 from './Includes/Step2';
import Step3 from './Includes/Step3';
import { addShipping, getServices } from 'utlis/Apis/Shipping_API';
import { toast } from 'react-toastify'
import { SHIPPING_ADDED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_CREATING_SHIPPING } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { useFormik } from 'formik';
import { ERROR_WHILE_FETCHING_SHIPPINGS } from 'utlis/AppMessages/AppMessages';
import { getCustomerCountries } from 'utlis/Apis/Customers_API';
import { getError } from 'utlis/AppMessages/AppMessages';

function AddShipping(props) {
    const [loading, setLoading] = useState(true)
    const [goSteps, setGoSteps] = useState(0);
    const [shipping, setShipping] = useState({})
    const [services, setServices] = useState({})
    const [countries, setCountries] = useState({})
    const [disableButton, setDisableButton] = useState(false)
    const setShippingData = (shippingData) => {
        setShipping({ ...shippingData })
    }
    useEffect(() => {
        setLoading(true)
        getServices(props.currentUser.userToken).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setServices(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_SHIPPINGS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getShippings `, err.message)

            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setLoading(false)
                }
            })
        })
        getCustomerCountries().then(res => {
            const countriesData = res.data
            if (countriesData.success) {
                setCountries(countriesData.data)
            }
            if (countriesData.error) {
                console.log('Error occured while loading countries groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }, [props.currentUser.token, props])

    const addShipping_ = (values) => {
        setLoading(true)
        setDisableButton(true)
        addShipping(props.currentUser.userToken, values).then(res => {
            setDisableButton(false)
            setLoading(false)
            setGlobalLoading(false)
            const shippingData = res.data
            if (shippingData.success) {
                window.scrollTo(0, 0)
                toast.dismiss();
                props.history.push('/settings/shippings', {
                    shouldReload: true
                })
                toast.success(SHIPPING_ADDED_SUCCESSFULLY, {
                    autoClose: 2000,
                    onClose: () => { }
                })
            }
            if (shippingData.error) {
                setLoading(true)
                console.log(ERROR_WHILE_CREATING_SHIPPING, res)
                toast.dismiss();
                toast.error(getError(shippingData.message, ERROR_WHILE_CREATING_SHIPPING) || ERROR_WHILE_CREATING_SHIPPING, {
                    autoClose: 3000,
                })
                setLoading(false)
                setDisableButton(false)
            }
        }).catch(err => {
            setLoading(false)
            console.log(`${ERROR_WHILE__NAME} addShipping `, err.message)
            toast.dismiss();
            toast.error(err.message || UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setGlobalLoading(false)
                }
            })
        })
    }

    const formik = useFormik({

    })

    return (
        <section
            id="app-saleOrders__create-details"
            className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-saleOrders__create-details">
                    <div className="app-header-wrapper mb-4">
                        <div className="back-button-wrapper mb-2">
                            <Link
                                to="/settings/shippings"
                                className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                                <FeatherIcon
                                    icon="arrow-left"
                                    size="14"
                                    className="icon me-1" />
                                <span>Back</span>
                            </Link>
                        </div>
                        <p className="app-heading text-capitalize">New Shipping Method</p>
                    </div>
                    <div
                        className="sale-content-container">
                        <div className="sale-order-steps">
                            <div className="sale-order-stepper">
                                <div className="stepper-container">
                                    <div className="stepper-step">
                                        <button className={`${goSteps === 0 ? "active" : "completed"}`}
                                            disabled={loading}
                                            onClick={(e => {
                                                if (goSteps > 0) {
                                                    setGoSteps(0)
                                                }
                                            })}

                                        >
                                            <span className="stepper-label">
                                                {goSteps === 0 ? "1" :
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    />}
                                            </span>
                                        </button>
                                        <div className={`stepper-title ${goSteps === 0 ? "active" : "completed"}`}>
                                            <span className="step-label" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>
                                                Select shipping method
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stepper-container">
                                    <div className="vertical-border active">
                                        <span className={`center-border ${goSteps === 0 ? "active" : "completed"}`}></span>
                                    </div>
                                    <div className="stepper-step">
                                        <button className={`${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}
                                            disabled={loading}
                                            onClick={(e => {
                                                if (goSteps > 1) {
                                                    setGoSteps(1)
                                                }
                                            })}
                                        >
                                            <span className="stepper-label">
                                                {
                                                    goSteps > 1 ? <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    /> :
                                                        goSteps !== 0 ? "2" :
                                                            goSteps === 0 ? "2" : ""
                                                }

                                            </span>
                                        </button>
                                        <div className={`stepper-title ${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}>
                                            <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>{!shipping.shipping_name ? "Set up rates" : `Set up rates for ${shipping.shipping_name}`}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stepper-container">
                                    <div className="vertical-border">
                                        <span className={`center-border ${goSteps === 2 ? "completed" : ""}`}></span></div>
                                    <div className="stepper-step">
                                        <button className={`${goSteps > 2 ? "active" : ""}`}
                                            disabled={loading}
                                            onClick={(e => {
                                                if (goSteps > 1) {
                                                    setGoSteps(1)
                                                }
                                            })}
                                        >
                                            <span className="">
                                                {
                                                    goSteps > 2 ? <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    /> :
                                                        "3"
                                                }
                                            </span>

                                        </button>
                                        <div className={`stepper-title ${goSteps > 2 ? "completed" : goSteps !== 0 && goSteps !== 1 ? "active" : goSteps === 0 && goSteps === 1 ? "" : ""}`}>
                                            <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>
                                                Finalize
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {goSteps === 0 && (
                            <Step1
                                goSteps={goSteps}
                                setGoSteps={setGoSteps}
                                loading={loading}
                                services={services}
                                shipping={shipping}
                                setShipping={setShippingData}
                                formik={formik}
                            />
                        )}
                        {goSteps === 1 && (
                            <Step2
                                goSteps={goSteps}
                                setGoSteps={setGoSteps}
                                shipping={shipping}
                                services={services}
                                setShipping={setShippingData}
                                formik={formik}
                            />
                        )}
                        {goSteps === 2 && (
                            <Step3
                                goSteps={goSteps}
                                services={services}
                                setGoSteps={setGoSteps}
                                shipping={shipping}
                                setShipping={setShippingData}
                                addShipping_={addShipping_}
                                loading={loading}
                                countries={countries}
                                disableButton={disableButton}
                            />
                        )}
                    </div>
                </div>
            </Container >
        </section >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddShipping)